import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from '../../posthog';

const GADS_ID = import.meta.env.VITE_GADS_ID as string | undefined;
const isProduction = import.meta.env.VITE_ENV === 'Production';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        path: location.pathname,
      });
    }
    if (typeof fbq === 'function') fbq('track', 'PageView');
    if (typeof gtag === 'function' && GADS_ID) {
      gtag('config', GADS_ID, {
        page_path: location.pathname,
        ...(!isProduction && { debug_mode: true }),
      });
    }
  }, [location.pathname]);
};
